var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7497_9637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.6077 18.8888C77.0919 18.1374 76.0648 17.9466 75.3133 18.4621C74.5618 18.978 74.3709 20.0052 74.8866 20.7565C85.4832 36.1944 83.5465 57.0246 70.2823 70.2864C55.0977 85.468 30.3914 85.468 15.2068 70.2864C7.85118 62.9324 3.80034 53.1547 3.80034 42.7545C3.80034 32.3542 7.85118 22.5765 15.2067 15.2222C28.4579 1.97376 49.2794 0.0283704 64.7153 10.5971C65.4671 11.1116 66.494 10.9198 67.009 10.1677C67.5239 9.4157 67.3318 8.3888 66.5796 7.87395C49.834 -3.59161 27.2471 -1.48302 12.8732 12.8885C4.89424 20.8659 0.5 31.4726 0.5 42.7545C0.5 54.0362 4.89424 64.643 12.8732 72.6203C20.8521 80.5978 31.4605 84.9914 42.7444 84.9914C54.0283 84.9914 64.6367 80.598 72.6156 72.6204C87.0041 58.2347 89.1036 35.6374 77.6077 18.8888V18.8888Z",
    fill: "#FF3B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4359 15.807C71.0179 16.1943 71.8012 16.1697 72.3567 15.7444C72.8791 15.3443 73.1182 14.6444 72.9458 14.0085C72.7611 13.3271 72.1473 12.8255 71.441 12.7872C70.7405 12.7491 70.0756 13.1769 69.8187 13.8291C69.537 14.5439 69.7956 15.3798 70.4359 15.807V15.807Z",
    fill: "#FF3B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4202 62.3541C37.6864 56.0895 47.882 56.0893 54.148 62.3542C54.4701 62.6763 54.8926 62.8374 55.3147 62.8374C55.7371 62.8374 56.1594 62.6762 56.4817 62.3539C57.1259 61.7095 57.1258 60.6646 56.4814 60.0201C48.9285 52.4689 36.6394 52.4687 29.0866 60.0202C28.442 60.6645 28.442 61.7093 29.0864 62.3539C29.731 62.9981 30.7757 62.9985 31.4202 62.3541V62.3541Z",
    fill: "#FF3B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4687 38.3808C52.8245 37.7363 51.7794 37.7364 51.135 38.381C50.4906 39.0254 50.4906 40.0703 51.1352 40.7147C53.5916 43.1708 56.8174 44.3983 60.044 44.3983C63.2701 44.3983 66.497 43.1703 68.9529 40.7147C69.5973 40.0704 69.5975 39.0255 68.9531 38.381C68.309 37.7366 67.264 37.7366 66.6194 38.3808C62.994 42.0058 57.0945 42.0058 53.4687 38.3808V38.3808Z",
    fill: "#FF3B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5017 38.3808C33.8571 37.7363 32.8124 37.7361 32.168 38.3807C28.5424 42.0054 22.6427 42.0058 19.0169 38.3807C18.3726 37.7361 17.3277 37.7364 16.6833 38.3808C16.0389 39.0252 16.039 40.0701 16.6834 40.7145C19.1396 43.1703 22.366 44.3982 25.5924 44.3982C28.8188 44.3982 32.0452 43.1703 34.5013 40.7145C35.1459 40.0703 35.1461 39.0254 34.5017 38.3808V38.3808Z",
    fill: "#FF3B30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7497_9637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84.5,
    height: 84.5,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.60414fc71ab3df25b57d57ea17dba01c.svg";
export { ForwardRef as ReactComponent };